module.exports = __webpack_public_path__ + "img/cp2-2.e4b0862c.jpg";